




































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  AgeAgeDTO,
  AgeManagerService,
  LiveManagementCreateLivecarpItemRequest,
  LiveManagementCreateLivecarpRequest,
} from "@/common/api";
import {
  DATE_MOMENT_FORMAT,
  DATE_TIME_TEXT_FORMAT,
  LANG,
  TIME_FORMAT,
} from "@/common/constant";
import {
  formatImageUrl,
  getAttributeByLangCamelCase,
  getAttributeByLangSnakeCase,
} from "@/common/utils";
import Paginate from "@/components/common/paginate.vue";
import store from "@/store";
import $ from "jquery";
import moment from "moment";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LivePreviewComponent",
  components: {
    Paginate,
  },
})
export default class LivePreviewComponent extends Vue {

  get itemPaginate() {
    this.paginateTotal = Math.ceil(this.items?.length / this.itemByPage);
    if (this.paginateTotal < this.currentPage) {
      this.currentPage = 1;
    }
    return this.items?.slice(
      (this.currentPage - 1) * this.itemByPage,
      this.currentPage * this.itemByPage,
    );
  }

  get startDate() {
    const { startDatetime } = this.live;

    return (
      this.formatJpDate(startDatetime) + " " + this.formatTime(startDatetime)
    );
  }

  get endDate() {
    const { startDatetime, endDatetime } = this.live;

    if (this.isSameDay(startDatetime, endDatetime)) {
      return this.formatTime(endDatetime);
    }

    return this.formatJpDate(endDatetime) + " " + this.formatTime(endDatetime);
  }
  public live = null as LiveManagementCreateLivecarpRequest;
  public items = [] as LiveManagementCreateLivecarpItemRequest[];
  public ages = [] as AgeAgeDTO[];

  public displayStyle = "";

  public imageUrls = [];
  public originalNames = [];
  public awsUrl = null;
  public youtubeUrl = null;
  public player = null;
  public itemDetail = null;
  public producers = [];
  public kinds = [];
  public page = null;
  public currentPage = 1;
  public itemByPage = 30;
  public paginateTotal = 1;

  public image = null;

  public settings = {
    arrows: true, // 前・次のボタンを表示する
    dots: true, // ドットナビゲーションを表示する
    dotsClass: "slick-dots custom-dot-class", // ドットナビゲーションの生成位置を変更
    speed: 1000, // スライドさせるスピード（ミリ秒）
    slidesToShow: 1, // 表示させるスライド数
    centerMode: true, // slidesToShowが奇数のとき、現在のスライドを中央に表示する
    variableWidth: true, // スライド幅の自動計算を無効化
  };

  public created() {
    this.getListAge();
    this.producers = this.items.map((item) => {
      const producer = this.getContentByLangCamelCase(item, "producer");
      if (producer) {
        return producer;
      }
    });
    this.currentPage = 1;
    this.paginateTotal = Math.ceil(this.items?.length / this.itemByPage);
    this.producers = this.producers.filter((item, index) => {
      return this.producers.indexOf(item) === index;
    });
    this.kinds = this.items.map((item) => {
      const kind = this.getContentByLangCamelCase(item, "kind");
      if (kind) {
        return kind;
      }
    });
    this.kinds = this.kinds.filter((item, index) => {
      return this.kinds.indexOf(item) === index;
    });
    this.getParameters();
  }

  public imageUrl(name, size, mode, background = "ffffff") {
    return formatImageUrl(name, size, mode, background);
  }

  public getDefaultThumbnailUrl(image) {
    return "/images/default/" + image;
  }

  public isDisabledImage(images) {
    if (!images) {
      return true;
    }

    return images.length === 0;
  }

  public mounted() {
    const link = document.createElement("link");
    link.setAttribute("href", "/css/slick.css");
    link.setAttribute("rel", "stylesheet");
    document.head.append(link);
  }

  public formatDate(date) {
    return moment(date).format(DATE_MOMENT_FORMAT);
  }

  public formatJpDate(date) {
    return moment(date).format(DATE_TIME_TEXT_FORMAT);
  }

  public formatTime(date) {
    return moment(date).format(TIME_FORMAT);
  }

  public getAltImage(original_name) {
    const number = this.getNumberOfImage(original_name);

    switch (number) {
      case "01":
        return "正面"; // Front view
      case "02":
        return "左側"; // Left side
      case "03":
        return "右側"; // Right side
      default:
        return "その他"; // Other
    }
  }

  public getNumberOfImage(filename) {
    if (!filename) { return 0; }
    const parts = filename.split("_");
    const number = parts[parts.length - 1];
    const dotIndex = number.indexOf(".");
    if (dotIndex !== -1) {
      return number.slice(0, dotIndex);
    }

    return number;
  }

  public isSameDay(date1, date2) {
    return moment(date1).isSameOrAfter(date2, "day");
  }

  public getContentByLangCamelCase(object, attributeName) {
    if (this.$route.query.lang) {
      return getAttributeByLangCamelCase(
        object,
        attributeName,
        this.$route.query.lang,
      );
    }

    return getAttributeByLangCamelCase(object, attributeName, LANG.JA);
  }

  public getContentByLangSnakeCase(object, attributeName) {
    if (!object) {
      return "";
    }
    if (this.$route.query.lang) {
      return getAttributeByLangSnakeCase(
        object,
        attributeName,
        this.$route.query.lang,
      );
    }

    return getAttributeByLangSnakeCase(object, attributeName, LANG.JA);
  }

  public translateAttribute(attributeName, value = null) {
    const currentLang = this.$route.query.lang ? this.$route.query.lang : LANG.JA;
    return this.$t(attributeName, `${currentLang}`, value);
  }

  public updateCurrent(page) {
    this.currentPage = page;
    this.setParameters({ page });
  }
  public setParameters(parameters) {
    const url = new URL(window.location.href);
    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        url.searchParams.set(key, value.toString());
      } else {
        url.searchParams.delete(key);
      }
    }
    window.history.pushState({}, "", url.toString());
  }
  public getParameters() {
    const url = new URL(window.location.href);
    this.currentPage = url.searchParams.get("page")
      ? Number(url.searchParams.get("page")) - 0
      : 1;
  }

  public beforeUpdate() {
    $("#js-slider-2").slick("unslick");
  }

  public updated() {
    $("#js-slider-2").slick({
      arrows: true, // 前・次のボタンを表示する
      dots: true, // ドットナビゲーションを表示する
      appendDots: $(".dots-2"), // ドットナビゲーションの生成位置を変更
      speed: 1000, // スライドさせるスピード（ミリ秒）
      slidesToShow: 1, // 表示させるスライド数
      centerMode: true, // slidesToShowが奇数のとき、現在のスライドを中央に表示する
      variableWidth: true, // スライド幅の自動計算を無効化
    });
  }

  public showPhotos(images, title, code) {
    $(".titlePhoto").text(title + " [" + code + "]");
    this.imageUrls = [];
    this.imageUrls = [...this.imageUrls, ...images.map((image) => image.name)];
    this.originalNames = [];
    this.originalNames = [
      ...this.originalNames,
      ...images.map((image) => image.originalName),
    ];
    $("#photo").prop("checked", true);
  }

  public showMovie(movie, title, code) {
    $(".titleMovie").text(title + " [" + code + "]");
    this.youtubeUrl = null;
    this.awsUrl = null;
    if (
      this.$route.query.lang === LANG.JA ||
      this.$route.query.lang === LANG.EN ||
      !this.$route.query.lang
    ) {
      this.youtubeUrl = movie.youtube ? movie.youtubeLink : null;
      this.awsUrl = this.youtubeUrl
        ? null
        : (movie.isConverted
          ? movie.videoLink
          : null);
    } else {
      this.awsUrl = movie.isConverted ? movie.videoLink : null;
    }
    if (this.awsUrl !== null) {
      if (this.player) {
        this.player.src(this.awsUrl);
        this.player.autoplay(true);
      } else {
        this.player = videojs(this.$refs.videoPlayer as HTMLElement, {
          autoplay: true,
          controls: true,
          sources: [
            {
              src: this.awsUrl,
              type: "application/x-mpegURL",
            },
          ],
        });
      }
    }
    $("#movie").prop("checked", true);
  }

  public beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }

  public showDetail(item) {
    this.itemDetail = item;
  }

  public closeButton() {
    $("#movie").prop("checked", false);
    $(".Movie iframe").attr("src", $(".Movie iframe").attr("src"));
    if (this.player) {
      this.player.src(this.player.src());
      this.player.autoplay(false);
    }
  }

  private async getListAge() {
    this.live = store.state.Live.live;
    this.items = store.state.Live.live.livecarpItems;
    const result = await AgeManagerService.adminAge({});
    this.ages = result.data.ages;
  }
}
